import { useQuery } from "@tanstack/react-query";
import { getCategoryFeaturedImages } from "../api/endpoints";

const queryKey = ["featuredCategories"];

export default function useFeaturedCategories() {
  return useQuery({
    queryKey,
    queryFn: ({ signal }) => getCategoryFeaturedImages({ signal }),
    staleTime: 10 * 60 * 1000,
    select: (data) => data?.categories || [],
  });
}
